export default "__VITE_ASSET__Cv9V1Cxj__"